module.exports = __webpack_public_path__ + "static/media/encabezado2.43f471cb.png";